// Constants for Power BI Report List
const POWERBI_REPORTS_DATA = {
  POWERBI_REPORTS_DATA_LOAD: "POWERBI_REPORTS_DATA_LOAD",
  POWERBI_REPORTS_DATA_SUCCESS: "POWERBI_REPORTS_DATA_SUCCESS",
  POWERBI_REPORTS_DATA_FAIL: "POWERBI_REPORTS_DATA_FAIL",
};

const POWERBI_REPORTS_GET_API = "/powerbi/reports";

// Constants for All Power BI Reports (without filters)
const POWERBI_ALL_REPORTS_DATA = {
  POWERBI_ALL_REPORTS_DATA_LOAD: "POWERBI_ALL_REPORTS_DATA_LOAD",
  POWERBI_ALL_REPORTS_DATA_SUCCESS: "POWERBI_ALL_REPORTS_DATA_SUCCESS",
  POWERBI_ALL_REPORTS_DATA_FAIL: "POWERBI_ALL_REPORTS_DATA_FAIL",
};

const POWERBI_ALL_REPORTS_GET_API = "/powerbi/reports/all";

// Constants for Embed URL and Token
const POWERBI_EMBED_URL_DATA = {
  POWERBI_EMBED_URL_DATA_LOAD: "POWERBI_EMBED_URL_DATA_LOAD",
  POWERBI_EMBED_URL_DATA_SUCCESS: "POWERBI_EMBED_URL_DATA_SUCCESS",
  POWERBI_EMBED_URL_DATA_FAIL: "POWERBI_EMBED_URL_DATA_FAIL",
};

const POWERBI_EMBED_URL_POST_API = "/powerbi/embed-token";

// Constants for Selected Report Details
const POWERBI_REPORT_GET_DATA = {
  POWERBI_REPORT_GET_DATA_LOAD: "POWERBI_REPORT_GET_DATA_LOAD",
  POWERBI_REPORT_GET_DATA_SUCCESS: "POWERBI_REPORT_GET_DATA_SUCCESS",
  POWERBI_REPORT_GET_DATA_FAIL: "POWERBI_REPORT_GET_DATA_FAIL",
};

const POWERBI_REPORT_GET_DETAIL_API = "/reports/";

// Constants for Setting Selected Report (local state only)
const POWERBI_SET_SELECTED_REPORT = "POWERBI_SET_SELECTED_REPORT";

// Constants for Profile View Toggle (local state only)
const POWERBI_SET_PROFILE_VIEW = "POWERBI_SET_PROFILE_VIEW";

// Constants for Favorite Reports
const POWERBI_FAVORITES_DATA = {
  POWERBI_FAVORITES_DATA_LOAD: "POWERBI_FAVORITES_DATA_LOAD",
  POWERBI_FAVORITES_DATA_SUCCESS: "POWERBI_FAVORITES_DATA_SUCCESS",
  POWERBI_FAVORITES_DATA_FAIL: "POWERBI_FAVORITES_DATA_FAIL",
};

const POWERBI_FAVORITES_GET_API = "/powerbi/favorites";

// Constants for Add Favorite Report
const POWERBI_ADD_FAVORITE = {
  POWERBI_ADD_FAVORITE_LOAD: "POWERBI_ADD_FAVORITE_LOAD",
  POWERBI_ADD_FAVORITE_SUCCESS: "POWERBI_ADD_FAVORITE_SUCCESS",
  POWERBI_ADD_FAVORITE_FAIL: "POWERBI_ADD_FAVORITE_FAIL",
};

const POWERBI_ADD_FAVORITE_POST_API = "/powerbi/favorites";

// Constants for Remove Favorite Report
const POWERBI_REMOVE_FAVORITE = {
  POWERBI_REMOVE_FAVORITE_LOAD: "POWERBI_REMOVE_FAVORITE_LOAD",
  POWERBI_REMOVE_FAVORITE_SUCCESS: "POWERBI_REMOVE_FAVORITE_SUCCESS",
  POWERBI_REMOVE_FAVORITE_FAIL: "POWERBI_REMOVE_FAVORITE_FAIL",
};

const POWERBI_REMOVE_FAVORITE_DELETE_API = "/powerbi/favorites/";

export {
  POWERBI_REPORTS_DATA,
  POWERBI_REPORTS_GET_API,
  POWERBI_ALL_REPORTS_DATA,
  POWERBI_ALL_REPORTS_GET_API,
  POWERBI_EMBED_URL_DATA,
  POWERBI_EMBED_URL_POST_API,
  POWERBI_REPORT_GET_DATA,
  POWERBI_REPORT_GET_DETAIL_API,
  POWERBI_SET_SELECTED_REPORT,
  POWERBI_SET_PROFILE_VIEW,
  POWERBI_FAVORITES_DATA,
  POWERBI_FAVORITES_GET_API,
  POWERBI_ADD_FAVORITE,
  POWERBI_ADD_FAVORITE_POST_API,
  POWERBI_REMOVE_FAVORITE,
  POWERBI_REMOVE_FAVORITE_DELETE_API,
};
